import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import Link from "../Link";
import MenuArrowIcon from "../../assets/svgs/menu-arrow-next.svg";

const EarnReferralHero = ({ content }) => {
  const heroImage = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "images/gift-and-coin.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <div id="earn-referral-hero">
      <div className="main-content  mt-auto">
        <div className="container">
          <div className="row">
            <div className="hero-content col-12 col-lg-6">
              <h1
                dangerouslySetInnerHTML={{
                  __html: content.hsMainHeading,
                }}
              />
              <div
                className="h2 m-0"
                dangerouslySetInnerHTML={{
                  __html: content.hsSubHeading,
                }}
              />
            </div>
            <div className="col-12 col-lg-6 hero-image w-100 h-auto text-center text-align-lg-end">
              <img src={heroImage.file.publicURL} />
            </div>
          </div>
        </div>
      </div>

      <div className="sub-content text-center">
        <div className="container">
          <div
            className="content text-black mx-auto"
            dangerouslySetInnerHTML={{ __html: content.hsMainText }}
          />
          <Link to={content.hsButtonLink} className="button mt-3">
            {content.hsButtonText}
            <MenuArrowIcon className="ml-2" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EarnReferralHero;
